import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { redirect } from './redirect';
import { environment } from '@fb-tool-front/environments/environment';
import { AppModule } from '@fb-tool-front/app.module';

const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop: string) => searchParams.get(prop)
});

if (params['redirect'] === 'true') {
  localStorage.removeItem('redirect');
} else if (params['redirect'] === 'false') {
  localStorage.setItem('redirect', 'false');
}

if (localStorage.getItem('redirect') === 'false') {
  bootstrap();
} else if (environment.redirectEnabled && environment.redirectUrl) {
  redirect(environment.ipGeoLocationKey, environment.redirectUrl).then(isRedirected => {
    if (!isRedirected) {
      bootstrap();
    }
  });
}

function bootstrap() {
  if (environment.sentry_enabled) {
    Sentry.init({
      dsn: environment.sentry_dsn,
      environment: environment.sentry_environment,
      normalizeDepth: 5
      // integrations(integrations) {
      //   return integrations.filter(i => i.name !== 'TryCatch');
      // }
    });
  }

  if (environment.production) {
    enableProdMode();
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    // .bootstrapModule(AppModule, { ngZoneEventCoalescing: true })
    .catch(err => console.error(err));
}
